import { render } from "./AdmFinalPlans.vue?vue&type=template&id=56c64625&scoped=true&ts=true"
import script from "./AdmFinalPlans.vue?vue&type=script&lang=ts"
export * from "./AdmFinalPlans.vue?vue&type=script&lang=ts"

import "./AdmFinalPlans.vue?vue&type=style&index=0&id=56c64625&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c64625"]])

export default __exports__